import React, { Dispatch, SetStateAction } from 'react'

import { Modal } from '@mui/material'
import Backdrop from '@mui/material/Backdrop'
import { Add } from '@mui/icons-material'
import manage from '/assets/Image/manage-wallets.png'
import click from '/assets/Image/click-arrow.png'
import CustomButton from 'components/Button/CustomButton'

export interface TopupCoachModalProps {
  TopupCoachModalOpen: boolean
  onClose: () => void
  onContinue: () => void
}

const TopupCoachModal = ({
  TopupCoachModalOpen,
  onClose,
  onContinue
}: TopupCoachModalProps) => {
  const handleClose = () => {
    onClose()
  }

  const handleContinue = () => {
    onClose()
    onContinue()
  }

  return (
    <Modal
      open={TopupCoachModalOpen}
      onClose={handleClose}
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500
      }}
      className="modal-bg overflow-auto"
    >
      <div className="absolute left-1/2 top-1/2 flex size-full translate-x-[-50%] translate-y-[-50%] flex-col items-center justify-center px-4">
        <div className="flex max-w-[480px] flex-col items-center rounded-md bg-black1 p-4 text-white">
          <div className="flex w-full">
            <button
              className="flex w-full cursor-pointer items-end justify-end"
              onClick={onClose}
            >
              <Add
                style={{
                  transform: `rotate(45deg)`,
                  color: '#ffffff',
                  fontSize: '30px'
                }}
              />
            </button>
          </div>
          <p className="pb-2 text-2xl font-bold">After Top-up Tip</p>
          <p className="pb-5 text-center text-sm text-grey3">
            Once your top-up has been successful, there are two steps that you
            need to take in order for the funds to reflect in your account.
          </p>
          <div className="pb-1 text-center font-bold">
            Step 1: Go to manage your wallets from the user menu
          </div>
          <img
            src={manage}
            alt="NFT question mark logo"
            className="mx-auto mb-4 w-4/5"
          />
          <div className="pb-1 text-center font-bold">
            Step 2: Click the blue arrow to move funds to your Flow Address
          </div>
          <img
            src={click}
            alt="NFT question mark logo"
            className="mx-auto w-4/5"
          />

          {/* Add Continue button */}
          <div className="mb-6 mt-4 flex w-full justify-center">
            <CustomButton
              label="Add Funds"
              model="primary"
              variant="contained"
              onClick={handleContinue}
            />
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default TopupCoachModal
